import React from "react";
import { TbGalaxy } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { FaGooglePlay, FaAppStore } from "react-icons/fa";
import { PiCopyright } from "react-icons/pi";
const LoginPcPage = () => {
    const navigate = useNavigate()
    const year = new Date().getFullYear();
    return (
        <div className="mobile_dashboard_container">

            <div className="mobile_dashboard_cont">
                <p className="title_form" onClick={() => navigate("/")}><span className="ia_span"><i><TbGalaxy /></i></span>Erioon</p>
                <p>Erioon Mobile will soon be available on the App Store and Google Play!</p>
                <p>In the meantime, you can access it from your PC.</p>
                {/* <div className="mobile_dashboard_cont_icons">
                    <FaAppStore />
                    <FaGooglePlay />
                    </div> */}
                    <button className="save_btn_db" onClick={() => navigate("/")}>Back to homepage</button>
            </div>
            <div className="end_footer_item">
                <p><PiCopyright /> {year} Erioon.</p>
                <p>All rights reserved.</p>
            </div>
        </div>
    )
}

export default LoginPcPage